/* eslint-disable no-case-declarations */
import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    ammunition: [],
    ammunitionMetadata: {},
}

const AmmunitionReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_AMMUNITION:
            const { data, metadata } = action?.payload
            return { ...state, ammunition: data, ammunitionMetadata: metadata }
        default:
            return { ...state }
    }
}

export default AmmunitionReducer
